import { render } from "./AndroidLineProcessPerformanceDetection.vue?vue&type=template&id=5d13ba1e&scoped=true&ts=true"
import script from "./AndroidLineProcessPerformanceDetection.vue?vue&type=script&lang=ts"
export * from "./AndroidLineProcessPerformanceDetection.vue?vue&type=script&lang=ts"

import "./AndroidLineProcessPerformanceDetection.vue?vue&type=style&index=0&id=5d13ba1e&scoped=true&lang=css"
import "./AndroidLineProcessPerformanceDetection.vue?vue&type=style&index=1&id=5d13ba1e&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d13ba1e"]])

export default __exports__